<div class="agpr-newswire">
    <agpr-newsroom-left-sidebar
        [sidebarModel] = "sidebarModel"
        (selectionChange) = "loadPreviewPanel($event)"
        (showAmplifyDialog) = "showSupportDialog()"
        (deleteItem) = "deleteArticle($event)"
        [totalStories] = "totalStories"
        [selectedItem]="selectedItem"
        [itemLabel]="sidebarItemLabel"
        [noItemsText]="sidebarNoItemsText"
        [amplifyButtonLabel] = "sidebarAmplifyLabel"
        [sections] = "sidebarSections"
        [selectedSectionValue] = "sidebarSelectedSectionValue"
        (sectionChanged) = "sidebarSectionChanged($event)"
        [isFormDirty] = "inEditMode"
    >
    </agpr-newsroom-left-sidebar>
    <agpr-hype *ngIf="!showStoryPreview && !showLoader"></agpr-hype>

    <div class="agpr-newswire-article" *ngIf="showStoryPreview && !showLoader">
        <agpr-article
            [minDate]="minDate"
            [activeArticle] = "article"
            [contactsDataSource] = "contactsDataSource"
            [linksDataSource] = "linksDataSource"
            [viewModel] = "articleComponentViewModel"
            [preferredMethodList] = "preferredMethodList"
            (saveArticle) = "saveArticle()"
            (modelChange)="onModelChanged($event)"
        >
        </agpr-article>
    </div>

    <agpr-news-right-side-bar
        *ngIf = "showStoryPreview"
        [preferences]="preferences"
        [minDate]="minDate"
        [editingDelay]="editingDelay"
        [rightSideBarInterface] = "this"
        [remainingTextContents] = "remainingTextContents"
        [remainingImageContents] = "remainingImageContents"
        [remainingVideoContents] = "remainingVideoContents"
        [showLogoButton] = "articleComponentViewModel.showLogo"
        [aboutUsButton] = "articleComponentViewModel.showAboutUs"
        [contactButton] = "articleComponentViewModel.showContacts"
        [linkButton] = "articleComponentViewModel.showLinks"
        [showPublishErrors] = "articleComponentViewModel.showPublishErrors"
        [showDraftErrors] = "articleComponentViewModel.showDraftErrors"
        [statusId] = "article.articleStatus"
        [showPublishLater] = "showPublishLater"
        [reservedUrl] = "article.previewUrl"
        [reportUrl] = "article.reportUrl"
        [id] = "article.articleId"
        [isLoader] = "showLoader"
        [createdBy] = "createdBy"
        [industryList] = "industryList"
        [preferredMethodList] = "preferredMethodList"
        [createdDate] = "article.createdDate"
        [lastModifiedDate] = "article.lastModifiedDate"
        [(regions)] = "article.regions"
        [publishedDate] = "article.publishedDate"
        [(scheduledDate)] = "article.scheduledDate"
        [(scheduledTime)] = "article.scheduledTime"
        [(schedulingType)] = "deliverySchedulingType"
        [(industryId)]  = "article.industryId"
        [(metaData)] = "article.metaData"
        [(preferredMethodId)] = "article.preferredMethodId"
        [(contactName)] = "article.contactName"
        [(contactEmail)] = "article.contactEmail"
        [(contactPhone)] = "article.contactPhone"
        [(notesForEditor)] = "article.notesForEditor"
        [(timeZone)] = "article.timeZone"
        [remainingUSReleases] = "remainingUSReleases"
        [remainingUKReleases] = "remainingUKReleases"
        [remainingCanadaReleases] = "remainingCanadaReleases"
        [remainingNorthAmericaReleases] = "remainingNorthAmericaReleases"
        (modelChange)="onRightSideBarModelChanged()"
    >
    </agpr-news-right-side-bar>

</div>
<agpr-amplify-dialog
    [dataSource] = "storyList"
    [dropdownDataSource] = "storyTypes"
    [(display)] = "displayAmplifyDialog"
    [isLoading] = "showAmplifyLoading"
    [accesswireSelected] = "true"
    (onCreateNewStory) = "onCreateNewArticle();"
    (onUseSelected) = "onAmplifyUseSelected($event);"
    (onCancel) = "onAmplifyCancel();"
    (onClose)="onAmplifyClose();"
    (onSelect)="onAmplifySelect($event)"
    (onSearch)="onAmplifySearch($event)"
    (onScroll)="onAmplifyScrollLoadData($event)"
    [totalRecords]="amplifyTotalRecords"
>
</agpr-amplify-dialog>

<div *ngIf="showLoader" class="agpr-previewPanel-overlay">
    <div [agprLoading]="true" class="loader"></div>
</div>
